module.exports = __webpack_public_path__ + "static/img/jygz.17e0aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jygz.png
// module id = bQPo
// module chunks = 3